import { useQueryCampaignsByThemePageId } from './useQueryCampaignsByThemePageId';
import { useCampaignStore } from '../stores/campaign';

export const useCampaignThemePage = () => {
  const campaignStore = useCampaignStore();

  const { isFetchedCampaignThemePage } = useQueryCampaignsByThemePageId();

  const campaign = computed(() => campaignStore.getters.getCampaignThemePage);
  const campaignId = computed(() => campaign?.value?.id);

  return {
    isFetchedCampaignThemePage,
    campaign,
    campaignId,
  };
};
